<template>
  <div class="tw:flex tw:flex-col tw:gap-y-4">
    <div class="tw:flex tw:flex-col tw:gap-y-1">
      <ul class="tw:flex tw:flex-col tw:gap-y-1">
        <li
          class="tw:text-sm tw:flex tw:items-start"
          v-for="(plusItem, plusIndex) in mainImagePlusPoints"
          :key="plusIndex"
        >
          <span class="tw:text-blue-700 tw:mr-1 tw:w-2">{{ '+ ' }}</span>
          <span>{{ $t(plusItem) }}</span>
        </li>
      </ul>
    </div>
    <div class="tw:flex tw:flex-row tw:gap-x-2">
      <div class="tw:flex tw:flex-col tw:gap-y-1">
        <img
          :src="ExteriorImage"
          :alt="$t('tbs_main_image_example_1')"
          class="tw:rounded-md"
          data-testid="main-image-example-exterior"
        />
        <p class="tw:text-xs tw:text-gray-700">{{ $t('tbs_main_image_example_1') }}</p>
      </div>
      <div class="tw:flex tw:flex-col tw:gap-y-1">
        <img
          :src="RoomImage"
          :alt="$t('image_not_permitted_5')"
          class="tw:rounded-md"
          data-testid="main-image-example-room"
        />
        <p class="tw:text-xs tw:text-gray-700">{{ $t('tbs_main_image_example_2') }}</p>
      </div>
      <div class="tw:flex tw:flex-col tw:gap-y-1">
        <img
          :src="AmenitiesImage"
          :alt="$t('tbs_main_image_example_3')"
          class="tw:rounded-md"
          data-testid="main-image-example-amenities"
        />
        <p class="tw:text-xs tw:text-gray-700">{{ $t('tbs_main_image_example_3') }}</p>
      </div>
    </div>

    <div class="tw:w-full tw:h-[1px] tw:flex tw:bg-gray-300" />
    <div class="tw:flex tw:flex-col tw:gap-y-1">
      <ul class="tw:flex tw:flex-col tw:gap-y-1">
        <li
          class="tw:text-sm tw:flex tw:items-start"
          v-for="(minusItem, minusIndex) in mainImageMinusPoints"
          :key="minusIndex"
        >
          <span class="tw:text-red-700 tw:mr-1 tw:w-2">{{ '- ' }}</span>
          <span>{{ $t(minusItem) }}</span>
        </li>
      </ul>
    </div>

    <div class="tw:flex tw:flex-row tw:gap-x-2">
      <div class="tw:flex tw:flex-col tw:gap-y-1">
        <img
          :src="BlurryImage"
          :alt="$t('image_not_permitted_4')"
          class="tw:rounded-md"
          data-testid="main-image-disallowed-blurry"
        />
        <p class="tw:text-xs tw:text-gray-700">{{ $t('image_not_permitted_4') }}</p>
      </div>
      <div class="tw:flex tw:flex-col tw:gap-y-1">
        <img
          :src="NoPeopleImage"
          :alt="$t('image_not_permitted_1')"
          class="tw:rounded-md"
          data-testid="main-image-disallowed-people"
        />
        <p class="tw:text-xs tw:text-gray-700">{{ $t('image_not_permitted_1') }}</p>
      </div>
      <div class="tw:flex tw:flex-col tw:gap-y-1" data-testid="main-image-disallowed-contact">
        <img
          :src="NoContactDetailsImage"
          :alt="$t('image_not_permitted_6')"
          class="tw:rounded-md"
          data-testid="main-image-disallowed-contact"
        />
        <p class="tw:text-xs tw:text-gray-700">{{ $t('image_not_permitted_6') }}</p>
      </div>
    </div>
  </div>
</template>
<script setup>
//Can do images
const ExteriorImage = new URL(`../../../assets/img/property-details/property-images/exterior.png`, import.meta.url)
const RoomImage = new URL(`../../../assets/img/property-details/property-images/room.png`, import.meta.url)
const AmenitiesImage = new URL(`../../../assets/img/property-details/property-images/amenities.png`, import.meta.url)
//Can't do images
const BlurryImage = new URL(`../../../assets/img/property-details/property-images/blurry.png`, import.meta.url)
const NoPeopleImage = new URL(`../../../assets/img/property-details/property-images/no_people.png`, import.meta.url)
const NoContactDetailsImage = new URL(
  `../../../assets/img/property-details/property-images/no_contact_details.png`,
  import.meta.url
)

const mainImagePlusPoints = ['tbs_main_image_guideline_1', 'tbs_main_image_guideline_2', 'tbs_main_image_guideline_3']
const mainImageMinusPoints = ['tbs_main_image_guideline_4', 'tbs_main_image_guideline_5', 'tbs_main_image_guideline_6']
</script>
